module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/floral-819c7849fe24f554a5e95438191052b1.jpg";